import { DateTime } from 'luxon'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SupportedResultCodes } from '../../types'
import CarpayPaymentResult from '../CarpayPaymentFinished.component'
import { Time } from '../../PaymentFinished.style'

interface PaymentErrorProps {
    plate: string
    now: DateTime
    paymentStatus: Extract<SupportedResultCodes, 'Error' | 'Refused'>
}

const PaymentError = ({ plate, now, paymentStatus }: PaymentErrorProps) => {
    const { t } = useTranslation()

    return (
        <CarpayPaymentResult>
            <CarpayPaymentResult.Icon variant={paymentStatus} className="wemolo-cross-circle" />
            <CarpayPaymentResult.Title variant={paymentStatus}>
                <span data-testid="payment-error">{t('carpay.paymentFinished.error')}</span>
            </CarpayPaymentResult.Title>
            <CarpayPaymentResult.Subtitle>{t('carpay.paymentFinished.errorSubtitle')}</CarpayPaymentResult.Subtitle>
            <div>
                <FormPlateInput disabled readOnly value={plate} />
                <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
            </div>
        </CarpayPaymentResult>
    )
}

export default PaymentError
